import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import { GoLinkExternal } from 'react-icons/go';
import { Link } from 'react-router-dom';
import ReactCountryFlag from 'react-country-flag';
import {
  market,
  price,
  product_category,
  style,
  target_group,
} from '../../static/brands_wholesalers_data';

const DEFAULT_IMAGE =
  'https://res.cloudinary.com/ramizapp/image/upload/v1733293245/FNAD/z77dbcfjv6g2l7nta7wv.jpg';

const SalesAgentProfileCard = ({ profile, profileType, isSelected, onToggleSelect }) => {
  const item = profile?.brand || profile?.retailer || {};
  const profileId = item?.id;
  console.log('item', item);

  const sortedTargetGroup = [...(item.target_group || [])].sort((a, b) => {
    const aIsMen = a?.toLowerCase() === 'men';
    const bIsMen = b?.toLowerCase() === 'men';
    return aIsMen === bIsMen ? 0 : aIsMen ? -1 : 1;
  });

  const searchCategory =
    item?.main_category?.toLowerCase() || item?.product_category?.[0]?.toLowerCase();
  const searchStyle = item?.main_style?.toLowerCase() || item?.style?.[0]?.toLowerCase();
  const searchTargetGroup =
    item?.main_target_group?.toLowerCase() || sortedTargetGroup[0]?.toLowerCase();

  const category = product_category.find((i) => i.label?.toLowerCase() === searchCategory);
  const styleGroup = style.find((i) => i.label?.toLowerCase() === searchStyle);
  const target = target_group.find((i) => i.label?.toLowerCase() === searchTargetGroup);
  const priceGroup = price.find((i) => i.label?.toLowerCase() === item?.price?.[0]?.toLowerCase());
  const country = market.find((i) => i.label?.toLowerCase() === item?.country?.toLowerCase());

  return (
    <Col xs={12} md={6} lg={4} className="mb-3 w-100" style={{ height: '300px' }}>
      <Card
        className="d-flex flex-row h-100 border position-relative"
        style={{ borderColor: '#CABAAD', overflow: 'hidden' }}
      >
        <div
          className="position-absolute"
          style={{ top: '10px', left: '10px', zIndex: 10 }}
        >
          <input
            type="checkbox"
            className="form-check-input"
            checked={isSelected}
            onChange={() => onToggleSelect(profileId)}
            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
          />
        </div>

        <div
          className="position-relative"
          style={{
            flex: 1,
            backgroundImage: `url(${item?.profile_img || DEFAULT_IMAGE})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            height: '100%',
            filter: 'brightness(0.9)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <h4
            className="text-white text-center font-weight-bold px-2"
            style={{
              fontSize: '22px',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 1)',
            }}
          >
            {item?.name || '--'}
          </h4>

          <div
            className="position-absolute start-0 rounded-end py-2 px-2"
            style={{ top: 33, backgroundColor: '#f9f9f9' }}
          >
            <small className="d-block text-black text-left" style={{ fontSize: '9px' }}>
              ID: {profileId || '--'}
            </small>
          </div>
        </div>

        <div
          className="p-2 h-100"
          style={{ flex: 0.7, display: 'flex', backgroundColor: '#EFECE9' }}
        >
          <Row className="g-2">
            {target ? (
              <Col xs={6} className="text-center">
                <img src={target.imageBlack} width="22" height="28" alt="Target" />
                <small className="d-block" style={{ whiteSpace: 'nowrap' }}>
                  {target.label}
                </small>
              </Col>
            ) : (
              <Col xs={6} className="text-center">
                <small className="d-block">--</small>
              </Col>
            )}

            {category ? (
              <Col xs={6} className="text-center">
                <img src={category.imageBlack} width="22" height="28" alt="Category" />
                <small className="d-block" style={{ whiteSpace: 'nowrap' }}>
                  {category.label}
                </small>
              </Col>
            ) : (
              <Col xs={6} className="text-center">
                <small className="d-block">--</small>
              </Col>
            )}

            {priceGroup ? (
              <Col xs={6} className="text-center">
                <img src={priceGroup.imageBlack} width="22" height="28" alt="Price" />
                <small className="d-block" style={{ whiteSpace: 'nowrap' }}>
                  {priceGroup.smallLable}
                </small>
              </Col>
            ) : (
              <Col xs={6} className="text-center">
                <small className="d-block">--</small>
              </Col>
            )}

            {styleGroup ? (
              <Col xs={6} className="text-center">
                <img src={styleGroup.imageBlack} width="22" height="28" alt="Style" />
                <small className="d-block" style={{ whiteSpace: 'nowrap' }}>
                  {styleGroup.label}
                </small>
              </Col>
            ) : (
              <Col xs={6} className="text-center">
                <small className="d-block">--</small>
              </Col>
            )}

            {country ? (
              <Col xs={6} className="text-center">
                <ReactCountryFlag
                  countryCode={country.code}
                  svg
                  style={{ width: '25px', height: '25px' }}
                />
                <small className="d-block" style={{ whiteSpace: 'nowrap' }}>
                  {country.label}
                </small>
              </Col>
            ) : (
              <Col xs={6} className="text-center">
                <small className="d-block">--</small>
              </Col>
            )}

            <Col xs={6} className="text-center">
              <Link
                color="link"
                size="small"
                className="p-0"
                target="_blank"
                to={`/profile/${profileId}/${profileType}`}
              >
                <GoLinkExternal size={22} color="black" />
                <small className="d-block text-decoration-underline text-black">
                  Profile
                </small>
              </Link>
            </Col>

            <Col xs={12} className="text-center mt-1">
              <small
                className="d-block text-muted text-truncate px-1"
                title={item?.website || ''}
              >
                {item?.website || '--'}
              </small>
            </Col>
          </Row>
        </div>
      </Card>
    </Col>
  );
};

export default SalesAgentProfileCard;
